import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/logo.svg';
const _hoisted_1 = ["alt"];
const _hoisted_2 = {
    key: 0,
    class: "ml-2 text-sm text-white font-semibold"
};
import { useTenantStore } from '@/store/tenant';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Logo',
    props: {
        appTitle: {},
        isSmall: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const tenantStore = useTenantStore();
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createBlock(_component_router_link, {
                class: "h-full flex items-center justify-center",
                to: "/",
                title: _ctx.appTitle,
                style: { "background-color": "#2b2f3a" }
            }, {
                default: _withCtx(() => [
                    _createElementVNode("img", {
                        class: "h-3/4",
                        src: _imports_0,
                        alt: _ctx.appTitle
                    }, null, 8, _hoisted_1),
                    (_ctx.isSmall === false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(tenantStore).name ? `${_unref(tenantStore).name} - ${_ctx.appTitle}` : _ctx.appTitle), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["title"]));
        };
    }
});
